class LqdMaskedImageHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initResponsiveBg();
    this.initDynamicShape();

  }

  getDefaultSettings() {
    return {
      selectors: {
        responsiveBgElement: '[data-responsive-bg]',
        dynamicShapeElement: '[data-dynamic-shape]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $responsiveBgElement: this.$element.find(selectors.responsiveBgElement),
      $dynamicShapeElement: this.$element.find(selectors.dynamicShapeElement),
    }
  }

  initResponsiveBg() {

    this.elements.$responsiveBgElement.liquidResponsiveBG();

  }

  initDynamicShape() {

    this.elements.$dynamicShapeElement.liquidDynamicShape();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdMaskedImageHandler, { $element } );
};